import { Button, Card, Form, Image, message, Typography } from "antd";
import { InputOTP } from "antd-input-otp";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BE_HOST } from "../../config/config";
import { useSelector, useDispatch } from "react-redux";
import { USER_TOKEN } from "../../redux/types.js";
import Applogo from "./../../LOGOAPP.png";
import { CloseCircleOutlined } from "@ant-design/icons";
import { HandleOnclose } from "../../utils/hash.js";
import logo from "../../assets/marketPlacelogo.png";
import newLogo from "../../assets/new-aapaLogo.png";


import OtpInput from "react-otp-input";
const { Title } = Typography;
const RESEND_OTP_TIME_LIMIT = 300;
const Otp = () => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [isLoading2, setLoading2] = useState(false);
  const isMobile = window.innerWidth <= 768;
  const location = useLocation();
  const email = location.state?.email;
  const mobile = location.state.mobile;
  const flag = location.state.flag;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [otpValue, setOtpValue] = useState("");

  const [resendButtonDisabledTime, setResendButtonDisabledTime] = useState(
    RESEND_OTP_TIME_LIMIT,
  );
  let resendOtpTimerInterval;

  useEffect(() => {
    setIsTimerActive(location.state?.active);
  }, [location]);

  const handleFinish = (values) => {
    console.log("OTP Submitted:", values);
    // Your OTP verify logic here
  };

  // console.log(mobile,'mobileeeeee',flag,"flafffff")

  useEffect(() => {
    if (isTimerActive) {
      startResendOtpTimer();
    } else {
      clearInterval(resendOtpTimerInterval);
    }

    return () => {
      if (resendOtpTimerInterval) {
        clearInterval(resendOtpTimerInterval);
      }
    };
  }, [isTimerActive, resendButtonDisabledTime]);
  const startResendOtpTimer = () => {
    if (resendOtpTimerInterval) {
      clearInterval(resendOtpTimerInterval);
    }
    resendOtpTimerInterval = setInterval(() => {
      if (resendButtonDisabledTime <= 0) {
        setIsTimerActive(false);
        clearInterval(resendOtpTimerInterval);
      } else {
        setResendButtonDisabledTime(resendButtonDisabledTime - 1);
      }
    }, 1000);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  // console.log(userAuth, "userAuthuserAuth")

  const handleVerifyOTP = async (values) => {
    // console.log(values, "valuesssss")
    const otpArray = values.otp; // This is an array
    // const otpString = otpArray.join("");
    // if (!otpString) {
    //   message.error('Please first Enter Otp')
    //   return;
    // } else if (otpString?.length < 6) {
    //   // message.error('Enter a Valid Otp');
    //   return;
    // }
    if (!otpArray) {
      message.error("Please first Enter Otp");
      return;
    } else if (otpArray?.length < 6) {
      // message.error('Enter a Valid Otp');
      return;
    }
    setLoading(true);
    const payload = {
      email: email,
      otp: otpArray,
    };
    try {
      // console.log(" Sending request...");
      const response = await axios.post(
        `${BE_HOST}/auth/verify-phone`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: "Bearer yourAccessToken"
          },
        },
      );
      console.log("Response:", response.data);
      if (response.data?.user?.isPasswordReset == true) {
        localStorage.setItem("token", response.data?.tokens?.accessToken);
        localStorage.setItem("userInfo", JSON.stringify(response?.data));
        localStorage.setItem(
          "refreshToken",
          response.data.tokens?.refreshToken,
        );
        dispatch({
          type: USER_TOKEN,
          payload: {
            token: response.data?.tokens?.accessToken,
            decodedToken: response?.data,
          },
        });
        message.success(response.data?.message);
        navigate("/react-dashboard", {
          state: { email: email },
        });
      } else {
        message.info(response.data?.message);
        navigate("/reset-password", {
          state: { email: email, token: response?.data?.resetToken },
        });
      }
    } catch (error) {
      console.error(" Error:", error.response?.data || error.message);
      message.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
      console.log(" Cleanup or loading state reset here");
      // Example: setLoading(false);
    }
  };

  const ResendOtp = async () => {
    console.log(email, "email");
    setLoading2(true);
    const payload = {
      email: email,
    };

    try {
      // console.log(" Sending request...");
      const response = await axios.post(
        `${BE_HOST}/auth/resend-phone-otp`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: "Bearer yourAccessToken"
          },
        },
      );
      console.log("Response:", response.data);
      setIsTimerActive(true);
      setResendButtonDisabledTime(300);
      message.success(response.data?.message);
    } catch (error) {
      console.error(
        " Error in resend otp:",
        error.response?.data || error.message,
      );
      message.error(error?.response?.data?.message);
    } finally {
      setLoading2(false);
      console.log("in resend otp");
      // Example: setLoading(false);
    }
  };

  const UpdatePhone = () => {
    navigate("/MobileAuth", {
      state: { email: email, mobile: mobile },
    });
  };

  return (
    <div className="min-h-screen bg-[#000833] from-gray-50 to-gray-100 flex flex-col items-center justify-start pt-8 p-4">
      <div
        style={{
          alignSelf: "end",
          marginBottom: 10,
          right: 20,
          cursor: "pointer",
        }}
        onClick={() => HandleOnclose(dispatch)}
      >
        <CloseCircleOutlined style={{ fontSize: 24, color: "white" }} />
      </div>
      {/* <Image
        style={{ marginTop: "6px" }}
        src="./logo3.png"
        alt="AAPA Logo"
        preview={false}
        className=" rounded-md"
        width={180}
        height={180}
        shadow-md
        shadow-gray-300
      /> */}
           <div className="mb-6">
        <Image
          src={logo}
          alt="Logo"
          preview={false}
          className="mb-8"
          // className="w-18 h-18 sm:w-18 sm:h-18 object-contain rounded"
          width={200}
          height={90}
        />
        </div>
      <div
        className="w-full max-w-[800px] flex flex-col items-center bg-[#000833] rounded-2xl
       border-[3px] border-white 
       "
      >
        <Image
          style={{ marginTop: "28px", marginBottom: "28px" }}
          src={newLogo}
          alt="Logo"
          preview={false}
          className="mb-8"
          width={300}
          // height={25}
        />
        {/* <Card
        className="w-full max-w-[500px] shadow-lg rounded-lg overflow-hidden  bg-[#000833] mb-20 mr-10 ml-10"
        style={{
          backgroundColor: '#000833',
          padding: '30px 20px',
          //   border: 'none',

        }}
      > */}
        <Card
          className=" max-w-[550px] w-full shadow-lg rounded-lg overflow-hidden  bg-[#000833] mb-20 "
          style={{ marginRight: 10, marginLeft: 10 }}
        >
          <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <Title level={3} style={{ color: "#fff", margin: 0 }}>
              Enter OTP
            </Title>
            {/* <p style={{ color: '#aaa', marginTop: 8 }}>
            {!!mobile &&`Your Mobile Number  ${mobile}`} 
          </p> */}
            <p style={{ color: "#aaa", marginTop: 8 }}>
              {!!mobile && (
                <>
                  Your Mobile Number&nbsp;
                  <span
                    style={{
                      backgroundColor: "#e0f7fa", // light blue bg
                      color: "#000",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      fontWeight: "bold",
                    }}
                  >
                    {mobile}
                  </span>
                </>
              )}
            </p>
            <p style={{ color: "#aaa", marginTop: 8 }}>
              We’ve sent a 6-digit code to your number
            </p>
          </div>
          <Form form={form} layout="vertical" onFinish={handleVerifyOTP}>
            <Form.Item
              name="otp"
              rules={[{ required: true, message: "Please enter the OTP" }]}
              style={{ marginBottom: 8 }}
            >
              <OtpInput
                value={otpValue}
                onChange={(otp) => {
                  setOtpValue(otp);
                  form.setFieldsValue({ otp });
                  if (otp.length === 6) form.submit();
                }}
                numInputs={6}
                shouldAutoFocus
                inputType="tel"
                isInputNum
                containerStyle={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "clamp(6px, 2vw, 14px)",
                  marginLeft: "clamp(4px, 2vw, 10px)",
                  marginRight: "clamp(4px, 2vw, 10px)",
                  marginBottom: 3,
                }}
                renderInput={(props, index) => (
                  <input
                    {...props}
                    key={index}
                    style={{
                      width: "clamp(38px, 10vw, 45px)",
                      height: "clamp(44px, 12vw, 55px)",
                      fontSize: "clamp(20px, 5vw, 30px)",
                      fontWeight: "700",
                      borderRadius: 8,
                      padding: 0,
                      textAlign: "center",
                      border: "1px solid #d9d9d9",
                      boxSizing: "border-box",
                    }}
                  />
                )}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "1rem" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                block
                size="large"
                className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
                style={{
                  backgroundColor: "#0EA5E9",
                  borderColor: "#0EA5E9",
                  fontWeight: "bold",
                }}
              >
                Verify
              </Button>
            </Form.Item>
          </Form>

          {/* <Form onFinish={handleVerifyOTP} form={form} layout="vertical">
          <Form.Item
            name="otp"
            rules={[{ required: true, message: 'Please enter the OTP' }]}
          >
            <InputOTP
              // value={otpValue}
              autoSubmit={form}
              length={6}
              type='tel'
              inputType="numeric"
              inputStyle={{
                width: 80,
                height: 60,
                fontSize: 30,
                borderRadius: 8,
                marginRight: 7,
                padding:0
              }}
            //   onPaste={handleOtpPaste}
            //   onChange={(val) => {
            //   setOtpValue(val);
            //   form.setFieldsValue({ otp: val });
            //   if (val.length === 6) {
            //     form.submit();
            //   }
            // }}
            />
          </Form.Item>
             
          <Form.Item style={{ marginTop: '1rem' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
              size="large"
              className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
              style={{
                backgroundColor: '#0EA5E9',
                borderColor: '#0EA5E9',
                fontWeight: 'bold',
              }}
            >
              Verify
            </Button>
          </Form.Item>
         
        </Form> */}
          {/* <div style={{flexDirection:"row",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
         {!!flag &&<div style={{display:"flex",alignItems:"center",}}>
            <Button onClick={ UpdatePhone} >
             Update Phone
             </Button> 
             </div>} */}
          {isTimerActive == true && (
            <div
              style={{
                alignSelf: "flex-end",
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                marginRight: 10,
              }}
            >
              <div style={{ fontSize: 13, fontWeight: "700", color: "#fff" }}>
                {formatTime(resendButtonDisabledTime)}
              </div>
            </div>
          )}
          {!isTimerActive && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Button onClick={ResendOtp} loading={isLoading2}>
                Resend OTP
              </Button>
            </div>
          )}
          {/* </div> */}
          {!!flag && (
            <div
              style={{
                display: "flex",
                width: "70%",
                marginTop: 10,
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "flex-start" : "center",
              }}
            >
              <p
                style={{
                  color: "#aaa",
                  marginTop: 8,
                  fontSize: 12,
                  marginRight: 10,
                  marginRight: isMobile ? 0 : 10,
                  marginBottom: isMobile ? 8 : 0,
                }}
              >
                If It's not your your number. Click on update phone to change
                your mobile number
              </p>
              <Button onClick={UpdatePhone}>Update Phone</Button>
            </div>
          )}
        </Card>
      </div>
      <style>
        {`
          .ant-message .ant-message-notice {
            padding: 16px 24px;
          }

          .ant-message .ant-message-notice-content {
            font-size: 24px;
            min-height: 50px;
            display: flex;
            align-items: center;
          }
          
        `}
      </style>
    </div>
  );
};

export default Otp;
